import { useState, ChangeEvent } from 'react'
import api from '../../services/api'
import Button from './Button'

interface FileUploadProps {
  onUpload: (fileData: any) => void
  accept?: string
  label?: string
}

function FileUpload({ onUpload, accept, label = 'Choisir un fichier' }: FileUploadProps) {
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')
  const [fileName, setFileName] = useState('')

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    setFileName(file.name)
    setUploading(true)
    setError('')

    try {
      const data = await api.uploadFile('/media/upload', file)
      onUpload(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Upload failed')
    } finally {
      setUploading(false)
    }
  }

  return (
    <div className="file-upload">
      <label className="file-upload-label">
        <input
          type="file"
          onChange={handleFileChange}
          accept={accept}
          disabled={uploading}
          className="file-upload-input"
        />
        <Button as="span" disabled={uploading}>
          {uploading ? 'Upload...' : label}
        </Button>
      </label>

      {fileName && <span className="file-name">{fileName}</span>}
      {error && <span className="upload-error">{error}</span>}
    </div>
  )
}

export default FileUpload
